import React from "react";

const ContractsStepper = ({ stepNames, currentStep }) => {
    const totalSteps = stepNames.length + 1; // includes 'Start'
    const totalSegments = stepNames.length;
    const stepPercentage = (currentStep / totalSegments) * 100;
    const stepsArray = Array.from({ length: totalSteps }, (_, i) => i);

    return (
        <div className="stepper" style={{ width: "100%", padding: "10px 0" }}>
            <div style={{
                width: "100%",
                height: "8px",
                backgroundColor: "#e0e0e0",
                borderRadius: "4px",
                position: "relative"
            }}>
                <div style={{
                    width: `${stepPercentage}%`,
                    height: "100%",
                    backgroundColor: "#6ECEB2",
                    borderRadius: "4px",
                    transition: "width 0.3s ease-in-out"
                }} />
            </div>

            <div style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "5px"
            }}>
                {stepsArray.map(step => (
                    <div key={step} style={{textAlign: "center"}}>
                        <div style={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                            backgroundColor: step <= currentStep ? "#6ECEB2" : "#e0e0e0",
                            display: "inline-block",
                            color: step <= currentStep ? "#fff" : "transparent",
                            alignContent: "center",
                            fontWeight: "bold"
                        }}>
                            <b>{step !== 0 && step <= currentStep ? "✓" : ""}</b>
                        </div>
                        <p style={{marginTop: "5px", fontSize: "12px"}}>
                            {
                                step === 0
                                    ? "Start"
                                    : stepNames[step - 1] || `Step ${step}`
                            }
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ContractsStepper;